import { gsap, ScrollTrigger } from 'gsap/all';
import itsMobile from '../util/is-mobile';
import ccSlider from './expanding-carousel';
import { ScrollSmoother } from '../vendor/gsap/ScrollSmoother';
import smoov from '../util/smooth-scroll';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

// In case there is any pinning, you need smoov();
smoov();
ccSlider();

// Desktop breakpoint
const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
let boxWidth = '';
let totalWidth = '';
let dirFromLeft = '';

function boxSize() {
    if (mobileMediaQuery.matches) {
        boxWidth = 183;
    } else {
        boxWidth = 270;
    }

    totalWidth = boxWidth * 16; //  * n of boxes
    dirFromLeft = `+=${totalWidth}`;

    return { boxWidth, totalWidth, dirFromLeft };
}

boxSize();

const marqueeContainer = $('.marquee-infinity-scroller');
const marqueeWrapper = $('.marquee-infinity-scroller .wrapper');
const openings = $('.openings-panel-block');
const circlePic = $('.openings-panel-block .photo-wrapper-circle img');
const benefits = $('.benefits-photo-container');
const groupPhoto = $('.benefits-photo-container .photo-wrapper .column-img img');
const no01 = document.querySelectorAll('#no01 .marquee-box');

gsap.set('.marquee-box', {
    y: () => gsap.utils.random(-13, 13),
    rotate: 'random(-10, 13)',
});

const boxTl = gsap.timeline();

gsap.utils.toArray('.marquee-box').forEach((item) => {
    boxTl.to(item, {
        y: 'random(-12, 5, 16)',
        duration: 'random(5, 7)',
        rotate: 'random(-10, 13)',
        repeat: -1,
        repeatRefresh: true,
        ease: 'ease-in-out',
        transformOrigin: 'center',
        yoyo: true,
    }, 0)
        .progress(0.5);
});

const master = gsap.timeline();

function marquee(which, time, direction) {
    gsap.to(marqueeWrapper, { duration: 1, opacity: 1 });
    gsap.set(which, {
        x(i) {
            return i * boxWidth;
        },
    });

    function reverseRepeat() {
        master.reverse(0);
    }

    function complete() {
        master.restart(0);
    }

    // Modifier for wrapping the photos after they've travelled totalWidth
    const mod = gsap.utils.wrap(0, totalWidth);

    const action = gsap.timeline()
        .to(which, {
            x: direction,
            modifiers: {
                x: (x) => `${mod(parseFloat(x))}px`,
            },
            duration: time,
            ease: 'none',
            repeat: 500,
            onReverseComplete: reverseRepeat,
            onReverseCompleteParams: ['{self}'],
            onComplete: complete,
            onCompleteParams: ['{self}'],
        });

    return action;
}

master.add(marquee(no01, 60, dirFromLeft), 0);
ScrollTrigger.create({
    trigger: marqueeContainer,
    start: 'top 50%',
    end: 'bottom top-=180px',
    invalidateOnRefresh: true,

    onUpdate: (self) => {
        if (self.direction === 1) {
            gsap.to(master, {
                timeScale: 1,
            });
        } else {
            gsap.to(master, {
                timeScale: -1,
            });
        }
    },
    onEnter: () => { master.play(); },
    onEnterBack: () => {
        master.play();
        boxTl.play().progress(0.5);
    },
    onLeave: () => {
        boxTl.pause();
        master.pause();
        gsap.to(master, {
            timeScale: -1,
        });
    },
});

// Main resize function
function panelsResize() {
    // re-init master after recalc from boxSize()
    master.pause(0);
    master.clear();
    boxSize();
    master.add(marquee(no01, 60, dirFromLeft));
    master.play();
}

// Mobile scrolling triggers resize event so check if window width changed:
let screenWidth = $(window).width();

$(window).on('resize', () => {
    if ($(window).width() !== screenWidth) {
        panelsResize();

        screenWidth = $(window).width();
    }
});

// Scrolling text marquee with yellow (turbo) bg
const turboTween = gsap.to('.marquee__part', {
    xPercent: -100, repeat: -1, duration: 20, ease: 'linear',
}).totalProgress(0.5);

gsap.set('.marquee__inner', { xPercent: -50 });

function tileTweener() {
    const marqueeTween = gsap.timeline({
        scrollTrigger: {
            trigger: '.scrolling-marquee',
            scrub: true,
            start: 'top bottom',
            end: 'bottom top',
            invalidateOnRefresh: true,
            onEnter: () => { turboTween.play(); },
            onEnterBack: () => {
                turboTween.play();
            },
            onLeave: () => {
                turboTween.pause();
            },
            onUpdate: (self) => {
                if (self.direction === 1) {
                    gsap.to(turboTween, {
                        timeScale: 1,
                    });
                } else {
                    gsap.to(turboTween, {
                        timeScale: -1,
                    });
                }
            },
        },
    });

    return marqueeTween;
}

tileTweener();

// Openings
gsap.set(circlePic, { scale: 1.1 });

const circleTl = gsap.timeline({
    scrollTrigger: {
        trigger: openings,
        scrub: true,
        start: 'top bottom',
        end: 'top 30%',
    },

});

circleTl.to(circlePic, {
    duration: 1,
    scale: 1,
    ease: 'linear',
});

if ($('.brand-spinner').length > 0) {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.openings-panel-block',
            scrub: true,
            start: 'top bottom',
            end: 'bottom top',
        },
    });

    tl.to('.brand-spinner', { rotateZ: 180, ease: 'linear' });
}

// Benefits
if (!itsMobile()) {
    gsap.set(groupPhoto, { x: 120 });

    const groupPhotoTl = gsap.timeline({
        scrollTrigger: {
            trigger: benefits,
            scrub: true,
            start: 'top bottom',
            end: 'top 30%',
        },

    });

    groupPhotoTl.to(groupPhoto, {
        duration: 1,
        x: 0,
        ease: 'linear',
    });
}
